import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 110;
  background: #0a0a1a;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

export const Content = styled.article`
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 17px;
  line-height: 1.7;
  color: #e8e8e8;
  width: 100%;
  max-width: 848px;
  margin: 0 auto;
  padding: 0 24px 60px;
  -webkit-text-size-adjust: 100%;

  h1 {
    font-family: Georgia, 'Times New Roman', serif;
    font-weight: bold;
  }

  /* Headings */
  h2 {
    font-family: Georgia, 'Times New Roman', serif;
    font-size: 1.6em;
    font-weight: bold;
    margin-top: 40px;
    border-bottom: 2px solid #e8e8e8;
    padding-bottom: 6px;
  }

  h3 {
    font-family: Georgia, 'Times New Roman', serif;
    font-size: 1.25em;
    font-weight: bold;
    margin-top: 28px;
    color: #ddd;
  }

  p {
    margin: 16px 0px;
  }

  /* Code blocks */
  pre {
    background: #1a1a2e;
    border: 1px solid #333;
    border-radius: 6px;
    padding: 16px;
    font-family: Consolas, 'Courier New', monospace;
    font-size: 13px;
    line-height: 1.4;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  code {
    font-family: Consolas, 'Courier New', monospace;
    font-size: 0.9em;
    background: #1a1a2e;
    padding: 2px 6px;
    border-radius: 3px;
    color: #7fdbca;
  }

  /* Tables */
  table {
    border-collapse: collapse;
    width: 100%;
    margin: 20px 0;
    font-size: 0.9em;
  }

  th,
  td {
    border: 1px solid #444;
    padding: 8px 12px;
    text-align: left;
  }

  th {
    background: #1a1a2e;
    font-weight: bold;
  }

  td:first-child {
    font-weight: 500;
  }

  /* Lists */
  ul,
  ol {
    margin: 10px 0;
    padding-left: 24px;
  }

  li {
    margin-bottom: 8px;
  }

  /* Links */
  a {
    color: #5dade2;
    text-decoration: underline;
  }

  /* HR */
  hr {
    border: none;
    border-top: 2px solid #333;
    margin: 36px 0;
  }

  /* Bold */
  strong {
    color: #fff;
  }

  /* Fee tree */
  .fee-tree {
    background: #1a1a2e;
  }

  @media screen and (max-width: 768px) {
    font-size: 18px;
    padding: 0 16px 60px;
    line-height: 1.75;

    h2 {
      font-size: 1.45em;
      margin-top: 32px;
    }

    h3 {
      font-size: 1.15em;
      margin-top: 24px;
    }

    pre {
      font-size: 12px;
      padding: 12px;
    }

    li {
      margin-bottom: 10px;
    }
  }
`;

export const TitlePage = styled.div`
  text-align: left;
  padding-top: 40px;

  h1 {
    margin-right: 50px;
    font-size: 2em;
    font-weight: bold;
    margin-bottom: 8px;
    color: #fff;
    line-height: 1.2;
  }

  h2 {
    font-size: 1.25em;
    font-weight: bold;
    color: #ccc;
    margin-top: 0;
  }

  @media screen and (max-width: 768px) {
    padding-top: 24px;

    h1 {
      font-size: 1.7em;
    }

    h2 {
      font-size: 1.1em;
    }
  }
`;

export const Version = styled.div`
  font-size: 1.1em;
  font-weight: bold;
  margin-top: 32px;
`;

export const Meta = styled.div`
  margin-top: 32px;
  font-size: 1em;
  line-height: 2;

  strong {
    display: inline-block;
    min-width: 90px;
  }
`;

export const Contact = styled.div`
  margin-top: 32px;
  font-size: 1em;
  line-height: 2;
`;

export const AwardsList = styled.ul`
  margin: 8px 0 0 0;
  padding-left: 0;
  list-style: none;
  line-height: 1.6;

  li {
    margin-bottom: 6px;
  }
`;

export const Abstract = styled.div`
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #555;
  font-style: italic;
  font-size: 0.95em;
  color: #bbb;
`;

export const QvaSection = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;
  margin: 24px 0;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const QvaText = styled.div`
  flex: 1;
  min-width: 0;
`;

export const QvaFrog = styled.div`
  flex-shrink: 0;

  pre {
    font-family: Consolas, monospace;
    font-size: 7.5pt;
    line-height: 1.2;
    margin: 0;
    padding: 0;
    background: none;
    border: none;
    white-space: pre;
  }

  @media screen and (max-width: 768px) {
    align-self: center;

    pre {
      font-size: 5.5pt;
    }
  }
`;

export const TableWrap = styled.div`
  @media screen and (max-width: 768px) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    margin: 16px -16px;
    padding: 0 16px;

    table {
      font-size: 0.85em;
      min-width: 600px;
    }

    th,
    td {
      padding: 6px 8px;
      white-space: nowrap;
    }
  }
`;

export const CompTable = styled.table`
  td:not(:first-child),
  th:not(:first-child) {
    text-align: center;
  }

  td:last-child {
    font-weight: bold;
  }
`;

export const Footer = styled.p`
  text-align: center;
  font-style: italic;
  color: #999;
`;
